import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Radio,
  AvatarGroup,
  Avatar,
  Pagination,
  Modal,
  createTheme,
  ThemeProvider,
  IconButton,
  CircularProgress,
} from "@mui/material";
import "@fontsource/manrope";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const theme = createTheme({
  typography: {
    fontFamily: "Manrope, Arial, sans-serif",
  },
});

const SprintSelectionPage = ({
  issueType,
  teamsLoading,
  teamsList,
  setTeamsList,
  selectedTeam,
  setSelectedTeam,
  setImportPageOpen,
  setSelectedProject,
}) => {
  const [page, setPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(true);

  const teamsPerPage = 6;

  const totalPages = Math.ceil(teamsList.length / teamsPerPage);
  const displayedTeams = teamsList.slice(
    (page - 1) * teamsPerPage,
    page * teamsPerPage
  );

  const handleRadioChange = (teamId) => {
    setSelectedTeam(teamId);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleBack = () => {
    setTeamsList([]);
    setSelectedProject(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
    setImportPageOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Modal open={isModalOpen}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 3,
            outline: "none",
            width: "500px",
            height: "500px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box display="flex" alignItems="center" gap={1} sx={{ ml: -1 }}>
              <ArrowBackIosNewIcon
                sx={{
                  fontSize: 11,
                  color: "#000000",
                  cursor: "pointer", // Makes it clear that the icon is clickable
                }}
                onClick={handleBack}
              />
              <Typography sx={{ fontSize: "16px" }}>Import Sprints</Typography>
            </Box>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography
            variant="subtitle2"
            sx={{ textAlign: "left", color: "text.secondary", mb: 2 }}
          >
            Select a sprint to move forward
          </Typography>

          {displayedTeams.length > 0 ? (
            <Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 2,
                  flex: 1,
                  overflowY: "auto",
                  mt: -1,
                }}
              >
                {displayedTeams.map((team) => (
                  <Card
                    key={team.id}
                    variant="outlined"
                    sx={{
                      p: 1.8,
                      borderRadius: 2,
                      width: "200px",
                      height: "85px",
                      border:
                        selectedTeam === team.id
                          ? "2px solid #1976d2"
                          : "1px solid #e0e0e0",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        ml: -1,
                        mb: 0.5,
                        mt: -1,
                      }}
                    >
                      <Radio
                        checked={selectedTeam === team.id}
                        onChange={() => handleRadioChange(team)}
                      />
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", lineHeight: 1.6 }}
                      >
                        {team.name}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: -0.5,
                        mb: 0.5,
                      }}
                    >
                      {/* <AvatarGroup max={5}>
                                        {team.teamMembers.map((member, idx) => (
                                            <Avatar key={idx} sx={{ width: 24, height: 24, fontSize: "0.8rem" }}>{member[0]}</Avatar>
                                        ))}
                                    </AvatarGroup> */}
                      {/* <Typography variant="caption" color="text.secondary">
                                        {team.teamMembers.length > 5 ? `+ ${team.teamMembers.length - 5} more` : ""}
                                    </Typography> */}
                    </Box>
                    {/* <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ mt: 1, ml: 0.5, lineHeight: 1.6 }}
                    >
                      Last updated {team.lastUpdate}
                    </Typography> */}
                  </Card>
                ))}
              </Box>
              {totalPages > 1 && (
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{ mt: 2, display: "flex", justifyContent: "center" }}
                />
              )}{" "}
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
                fontSize: "1rem",
                fontWeight: "bold",
                color: "text.secondary",
              }}
            >
              {teamsLoading ? (
                <CircularProgress />
              ) : (
                <Typography>No Sprints Available</Typography>
              )}
            </Box>
          )}
        </Box>
      </Modal>
    </ThemeProvider>
  );
};

export default SprintSelectionPage;
